// extracted by mini-css-extract-plugin
export default {"fullWidth":"Zh-z","hasStyledAspectRatio":"_h-z"};